<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-12">
          <div class="element-wrapper">
            <div class="element-box">
              <form @submit="guardar">
                <h5 v-if="!current.pk" class="form-header">Nueva Categoría</h5>
                <div v-if="!current.pk" class="form-desc">Adición Categoría</div>
                <h5 v-if="current.pk" class="form-header">Edición de Categoría</h5>

                <div class="row">
                  <div class="col-lg-3 col-sm-12 col-md-12">
                    <div class="form-group">
                      <label
                        v-bind:class="{ 'text-danger': current.errors.codigo && current.errors.codigo.length > 0 }"
                      >Código</label>
                      <input
                        v-model="current.codigo"
                        class="form-control"
                        autofocus="autofocus"
                        placeholder="Código"
                        :readonly="current.pk"
                        type="text"
                        v-bind:class="{ 'is-invalid': current.errors.codigo && current.errors.codigo.length > 0 }"
                      />
                      <small
                        v-if="current.errors && current.errors.codigo"
                        class="form-text text-danger"
                      >{{ current.errors.codigo[0] }}</small>
                    </div>
                  </div>
                  <div class="col-lg-9 col-sm-12 col-md-12">
                    <div class="form-group">
                      <label
                        v-bind:class="{ 'text-danger': current.errors.nombre && current.errors.nombre.length > 0 }"
                      >Nombre</label>
                      <input
                        v-model="current.nombre"
                        class="form-control"
                        placeholder="Nombre"
                        v-bind:class="{ 'is-invalid': current.errors.nombre && current.errors.nombre.length > 0 }"
                        type="text"
                      />
                      <small
                        v-if="current.errors && current.errors.nombre"
                        class="form-text text-danger"
                      >{{ current.errors.nombre[0] }}</small>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-4">
                    <div class="form-check">
                      <label class="form-check-label">
                        <input
                          checked
                          class="form-check-input"
                          name="optionsRadios"
                          v-model="current.estatus"
                          type="radio"
                          value="true"
                        />Activa
                      </label>
                    </div>
                    <div class="form-check">
                      <label class="form-check-label">
                        <input
                          class="form-check-input"
                          v-model="current.estatus"
                          name="optionsRadios"
                          type="radio"
                          value="false"
                        />Inactiva
                      </label>
                    </div>
                  </div>
                </div>

                <div class="form-buttons-w">
                  <button class="btn btn-primary" type="submit">Guardar</button>
                  <router-link
                    class="btn btn-info"
                    :to="{ name: 'cat-subcategorias', params: { categoria: current.codigo }}"
                  >
                    <i class="fa fa-back"></i>
                    Sub Categorias
                  </router-link>
                  <router-link
                    class="btn btn-default"
                    :to="{ name: 'cat-categorias', params: {  }}"
                  >
                    <i class="fa fa-back"></i>
                    Volver al Listado
                  </router-link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import PaginationComponent from "@/components/utils/PaginationComponent";
import CategoriaService from "@/services/catalogos/CategoriaService";
import Notifications from "@/notifications/notifications";

export default {
  data() {
    return {
      current: {
        errors: {}
      },
      data: []
    };
  },

  computed: {},
  mounted() {
    if (this.$route.params.id) {
      CategoriaService.getById(this.$route.params.id).then(response => {
        this.current = response.data;
        this.current.pk = this.current.codigo;
        this.current.errors = [];
      });
      this.refreshData();
    }
  },

  methods: {
    guardar(e) {
      let self = this;
      e.preventDefault();
      var current = Object.assign({}, this.current);
      
      if (current.codigo == null) {
        delete current.codigo;
      }
      CategoriaService.save(current)
        .then(res => {
          self.current = res.data;
          self.current.pk = self.current.codigo;
          self.current.errors = {};
          Notifications.alert.success(
            "Categoria",
            "Se ha guardado la Información."
          );
          self.$router.push({
            name: "cat-categorias-editar",
            params: { id: self.current.codigo }
          });
        })
        .catch(error => {
          if (error.response) {
            self.current.errors = error.response.data;
          }
        });
    },
    showModal(e) {
      e.preventDefault();
    },

    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: this.currentPage,
        "filter[search]": this.searchtext,
        activo: this.filterActivo
      });
    },
    filterData() {
      this.refreshData({
        page: 1,
        categoria: this.current.codigo,
        "filter[search]": this.searchtext,
        activo: this.filterActivo
      });
    },
    clearFilterData() {
      this.searchtext = "";
      this.filterActivo = null;
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        activo: this.filterActivo
      });
    },
    hide: function() {
      this.$data.destroy();
    },
    onRefreshData() {},
    refreshData(params) {
      let self = this;
    }
  }
};
</script>
